// import React, { useEffect, useState } from "react";
// import { Redirect } from "react-router-dom";

// const LocationGuard = ({ children }) => {
//   const [isAllowedState, setIsAllowedState] = useState(null);
//   const [locationChecked, setLocationChecked] = useState(false);

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         async function (pos) {
//           try {
//             const lat = pos?.coords?.latitude;
//             const lon = pos?.coords?.longitude;

//             if (!lat || !lon) {
//               setIsAllowedState(false);
//               setLocationChecked(true);
//               return;
//             }

//             const res = await fetch(
//               `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
//             );

//             if (!res.ok) {
//               throw new Error("Reverse API failed");
//             }

//             const data = await res.json();
//             const state = data?.address?.state;

//             if (state === "Uttar Pradesh" || state === "Delhi") {
//               setIsAllowedState(true);
//             } else {
//               setIsAllowedState(false);
//             }
//           } catch (error) {
//             console.log(error);
//             setIsAllowedState(false);
//           }

//           setLocationChecked(true);
//         },
//         function () {
//           setIsAllowedState(false);
//           setLocationChecked(true);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0,
//         }
//       );
//     } else {
//       setIsAllowedState(false);
//       setLocationChecked(true);
//     }
//   }, []);

//   if (!locationChecked) {
//     return <div>Checking location...</div>;
//   }

//   if (isAllowedState === false) {
//     return (
//       <div
//         style={{
//           height: "100vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
//           padding: "20px",
//         }}
//       >
//         <div
//           style={{
//             background: "#ffffff",
//             padding: "40px",
//             borderRadius: "12px",
//             boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//             textAlign: "center",
//             maxWidth: "420px",
//             width: "100%",
//           }}
//         >
//           <h1
//             style={{
//               fontSize: "64px",
//               margin: "0",
//               color: "#dc3545",
//               fontWeight: "bold",
//             }}
//           >
//             403
//           </h1>
  
//           <h2 style={{ margin: "10px 0 15px 0", color: "#343a40" }}>
//             Access Denied
//           </h2>
  
//           <p style={{ color: "#6c757d", marginBottom: "25px" }}>
//             Sorry, this application is not accessible from system.
           
//           </p>
  
//           <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
//             <button
//               onClick={() => window.location.reload()}
//               style={{
//                 padding: "10px 20px",
//                 borderRadius: "6px",
//                 border: "none",
//                 cursor: "pointer",
//                 background: "#dc3545",
//                 color: "#fff",
//                 fontWeight: "500",
//               }}
//             >
//               Retry
//             </button>
  
//             {/* <button
//               onClick={() => (window.location.href = "/")}
//               style={{
//                 padding: "10px 20px",
//                 borderRadius: "6px",
//                 border: "1px solid #6c757d",
//                 cursor: "pointer",
//                 background: "#fff",
//                 color: "#6c757d",
//                 fontWeight: "500",
//               }}
//             >
//               Go Home
//             </button> */}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return children;
// };

// export default LocationGuard;


import React, { useEffect, useState } from "react";

const LocationGuard = ({ children }) => {
  const [isAllowedState, setIsAllowedState] = useState(null);
  const [locationChecked, setLocationChecked] = useState(false);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async function (pos) {
          try {
            const lat = pos?.coords?.latitude;
            const lon = pos?.coords?.longitude;

            if (!lat || !lon) {
              setIsAllowedState(false);
              setLocationChecked(true);
              return;
            }

            const res = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
            );

            if (!res.ok) throw new Error("Reverse API failed");

            const data = await res.json();

            const country = data?.address?.country || "";
            const state = data?.address?.state || "";
            const city =
              data?.address?.city ||
              data?.address?.town ||
              data?.address?.village ||
              "";

            console.log("Country:", country);
            console.log("State:", state);
            console.log("City:", city);

            let isAllowed = false;

            if (country === "India") {
              if (
                state.toLowerCase() === "uttar pradesh" ||
                city.toLowerCase() === "mumbai"
              ) {
                isAllowed = true;
              }
            }

           if (
              country === "United Arab Emirates" &&
              city.toLowerCase() === "dubai"
            ) {
              isAllowed = true;
            }

            if (country === "Uzbekistan") {
              isAllowed = true;
            }

            setIsAllowedState(isAllowed);
          } catch (error) {
            console.log(error);
            setIsAllowedState(false);
          }

          setLocationChecked(true);
        },
        function () {
          setIsAllowedState(false);
          setLocationChecked(true);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      setIsAllowedState(false);
      setLocationChecked(true);
    }
  }, []);

  if (!locationChecked) {
    return <div>Checking location...</div>;
  }

  if (isAllowedState === false) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
          padding: "20px",
        }}
      >
        <div
          style={{
            background: "#ffffff",
            padding: "40px",
            borderRadius: "12px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            textAlign: "center",
            maxWidth: "420px",
            width: "100%",
          }}
        >
          <h1
            style={{
              fontSize: "64px",
              margin: "0",
              color: "#dc3545",
              fontWeight: "bold",
            }}
          >
            403
          </h1>

          <h2 style={{ margin: "10px 0 15px 0", color: "#343a40" }}>
            Access Denied
          </h2>

          {/* <p style={{ color: "#6c757d", marginBottom: "25px" }}>
            Access allowed only from:
            <br />
            • Uttar Pradesh (India)
            <br />
            • Mumbai (India)
            <br />
            • Dubai (UAE)
            <br />
            • Uzbekistan
          </p> */}

       
        </div>
      </div>
    );
  }

  return children;
};

export default LocationGuard;